import ptBR from "./ptBR";

const i18n = {
    ptBr: ptBR
}

export default i18n